import { render, staticRenderFns } from "./OpSelectBank.vue?vue&type=template&id=5cdd12c3"
import script from "./OpSelectBank.vue?vue&type=script&lang=js"
export * from "./OpSelectBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports